var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "sheepPage page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "game-box"
  }, [_c('div', {
    staticClass: "game-top-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Level')))]), _c('div', {
    staticClass: "text-xl font-bold"
  }, [_vm._v(_vm._s(_vm.level))])]), _c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-blue"
  }, [_vm._v(_vm._s(_vm.score))])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count"
  }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.leftTime)))]), _c('div', {
    staticClass: "time-text"
  }, [_vm._v(_vm._s(_vm.$lang('Award and reset after countdown.')))])])]), _c('div', [_c('div', {
    staticClass: "bg-white/80 rounded",
    on: {
      "click": _vm.viewRank
    }
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "width": "18",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.prizePool))])])])]), _c('div', {
    staticClass: "game-center-box relative flex-1"
  }, [_c('div', {
    staticClass: "absolute inset-0 flex items-center justify-center"
  }, [_c('div', {
    staticClass: "relative w-full h-64 md:h-96"
  }, _vm._l(_vm.deckTiles, function (tile) {
    return _c('SheepTileComponent', {
      key: tile.id,
      attrs: {
        "tile": tile
      },
      on: {
        "click": function ($event) {
          return _vm.handleTileClick(tile);
        }
      }
    });
  }), 1)])]), _c('div', {
    staticClass: "game-bottom-box relative"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('div', {
    staticClass: "bg-white/80 rounded font-bold text-xs"
  }, [_vm._v(" " + _vm._s(_vm.$lang(`Remaining tiles:`)) + _vm._s(_vm.deckTiles.length) + " ")]), _c('button', {
    class: `flex items-center btn-min  ${_vm.revives > 0 ? 'bg-blue' : 'bg-blue-500'}`,
    attrs: {
      "disabled": _vm.status !== 'playing' || _vm.revives <= 0 || _vm.slotTiles.length === 0
    },
    on: {
      "click": function ($event) {
        return _vm.handleMoveOutTiles(true);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang('Move out 3 tiles')))]), _c('span', {
    staticClass: "bg-white/20",
    staticStyle: {
      "padding": "0 5px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.revives) + " / " + _vm._s(_vm.maxRevives))])])]), _c('SheepSlotBarComponent', {
    attrs: {
      "tiles": _vm.slotTiles
    }
  })], 1)])])]), _c('pop-game-warn-prompt', {
    attrs: {
      "show": _vm.popOpenMobileShow,
      "message": _vm.$lang(`Please open this page on your mobile phone.`),
      "btnConfirmText": _vm.$lang('Back')
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenMobileShow = $event;
      },
      "confirm": function ($event) {
        return _vm.$router.back();
      }
    }
  }), _c('pop-game-start-prompt', {
    attrs: {
      "show": _vm.popStartShow,
      "message": _vm.$lang(`<li>Earn rewards by playing.</li>
<li>The higher your rank, the greater your reward.</li>
<li>Play multiple times within the countdown. Only your highest score will count for ranking.</li>
<li>All players will reset and start over once the countdown ends.</li>`)
    },
    on: {
      "update:show": function ($event) {
        _vm.popStartShow = $event;
      },
      "confirm": function ($event) {
        return _vm.startGame(1);
      }
    }
  }), _c('pop-game-win-prompt', {
    attrs: {
      "show": _vm.popWinShow,
      "title": _vm.$lang('Congratulations'),
      "message": _vm.$lang(`You completed the level ${_vm.level}`),
      "nextLevel": _vm.level + 1,
      "nextBtnText": _vm.nextBtnText
    },
    on: {
      "update:show": function ($event) {
        _vm.popWinShow = $event;
      },
      "confirm": _vm.handleNextLevel
    }
  }), _c('pop-game-lost-prompt', {
    attrs: {
      "show": _vm.popLostShow,
      "title": _vm.$lang('Game over'),
      "message": _vm.$lang('Slot is full! Do you want to use one revive to move out the top 3 tiles?'),
      "cancelText": _vm.revives > 0 ? _vm.$lang('Give up') : _vm.$lang('Restart from level 1'),
      "confirmText": _vm.revives > 0 ? _vm.$lang(`Move out 3 tiles (${_vm.revives}/${_vm.maxRevives})`) : _vm.$lang('Restart')
    },
    on: {
      "update:show": function ($event) {
        _vm.popLostShow = $event;
      },
      "cancel": _vm.handleCancel,
      "confirm": _vm.handleConfirm
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-rank', {
    attrs: {
      "gameType": 'sheep',
      "show": _vm.popGameRankShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRankShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };